__turbopack_context__.v({
  "emptyMessage": "streaming-channels-panel-module-scss-module__DPVdQa__emptyMessage",
  "platformIcon": "streaming-channels-panel-module-scss-module__DPVdQa__platformIcon",
  "platformIconCell": "streaming-channels-panel-module-scss-module__DPVdQa__platformIconCell",
  "platformIconFallback": "streaming-channels-panel-module-scss-module__DPVdQa__platformIconFallback",
  "platformUrl": "streaming-channels-panel-module-scss-module__DPVdQa__platformUrl",
});
